import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@met/react-components';
import React from 'react';

const ConfirmationModal = ({
  hidden,
  toggle,
  onConfirm,
  title,
  body,
  confirmButtonLabel,
}) => {
  return (
    <Modal centered hidden={hidden} toggle={toggle}>
      <ModalContent>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <p>{body}</p>
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle}>Cancel</Button>
          <Button primary onClick={onConfirm}>
            {confirmButtonLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

ConfirmationModal.defaultProps = {
  title: 'Confirmation',
  body: 'Are you sure you want to continue?',
  confirmButtonLabel: 'Yes',
};

export default ConfirmationModal;
